import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            role: '',
            filter: '',
            trainings: [],
            showAddDefinition: false,
            showChooseDefinition: false,
            addDefinitionDate: '',
            definitionDataToEdit: null,
            pagination: {
                page: 1,
                limit: 100,
                totalCount: 0
            },
        }
    },
    methods: {
        load: load,
        editCompany: editCompany,
        addCompany: addCompany,
        deleteTrainingDefinition: deleteTrainingDefinition,
        getName: getName,
        getShortDesc: getShortDesc,
        checkNullEmpty: checkNullEmpty,
        showDefinitionAdd: showDefinitionAdd,
        editDefinitionData: editDefinitionData,
        keymonitor: keymonitor,

    },
    watch: {
        'filter': function (newVal) {
            if (newVal.length === 0){
                this.pagination.page = 1;
                this.load()
            }
        }
    },

    created() {
        this.$topnavbar.$on('closeTrainingDefinitionWod', () => {
            this.addDefinitionDate = ''
            this.showAddDefinition = false
        });

        this.$topnavbar.$on('successTrainingDefinitionWod', () => {
            this.addDefinitionDate = ''
            this.showAddDefinition = false
            this.load();
        });
    },

    beforeMount() {
        if (session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.role = session.getRole();
        this.load()
    }
}


function showDefinitionAdd(item){
    this.definitionDataToEdit = null
    this.addDefinitionDate = item.date
    this.showAddDefinition = true
}

function editDefinitionData(item){
    this.definitionDataToEdit = item
    this.addDefinitionDate = item.date
    this.showAddDefinition = true
}

function load() {
    let _self = this;

    let request = {
        page: _self.pagination.page,
        limit: _self.pagination.limit,
        filter: _self.filter,
        type: "WOD"
    }

    AdminApiService.getTrainingDefinitions(request)
        .then((response) => {
            _self.trainings = response.data.results;
            _self.pagination.totalCount = response.data.totalCount;
        })
        .catch((error) => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function deleteTrainingDefinition(item){
    let _self = this;
    swal({
        title: LocService.t("label_delete_training_of_the_day"),
        text: LocService.t("label_delete_training_of_the_day_are_you_sure") + ": " + this.getName(item),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t("label_no"),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t("label_yes"),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.deleteTrainingDefinition(item.id)
            .then((response) => {
                swal(LocService.t("label_success"), LocService.t('label_delete_training_of_the_day_successfully'), 'success')
                _self.load();
            })
            .catch(error => {
                swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
            })

    })
}

function editCompany(company) {
    this.$router.push('/add-company-payment?id=' + company.id + '&name='+company.name)
}

function addCompany() {
    this.$router.push('/add-company-payment')
}



function formatDate(date) {
    return this.$moment(new Date(date * 1000)).format('DD-MM-YYYY')
}

function getName(item){
    if(session.getLocale() === LocService.getDefaultLanguage()){
        return item.name;
    }else if(item.enName != null && item.enName.length > 0){
        return  item.enName;
    }
    return item.name;
}

function getShortDesc(item){
    if(session.getLocale() === LocService.getDefaultLanguage()){
        return item.shortDescription;
    }else if(item.enShortDescription != null && item.enShortDescription.length > 0){
        return  item.enShortDescription;
    }
    return item.shortDescription;
}

function checkNullEmpty(item){
    if(item == null) return '/';
    if(item.length === 0) return '/';
    return item;
}

function keymonitor(event) {
    if (event.key === 'Enter') {
        this.load();
    }
}


// WEBPACK FOOTER //
// ./src/components/Wod/AllWodTrainings.js